import { CommunicationChannel, CommunicationCategory } from '../../../../pure-js/enums/Communication'
import {
  CHANNEL_OPT_OUT_TOGGLES,
  getAvailableCommunicationCategoryDefs,
  isCategoryOptedOut,
  isChannelOptedOut
} from '../../../../pure-js/libs/communicationCategories'
import type { CommunicationPreferences } from '../../../../pure-js/types/Preferences'
import type { SettingsValues } from '../settings/types'
import { categoryFieldKey, channelFieldKey } from './communicationSettingsSchema'

// Stored prefs -> form values. Toggles are positive ("receive"), so value = !optedOut.
export const communicationPreferencesToValues = (prefs: CommunicationPreferences | undefined): SettingsValues => {
  const values: SettingsValues = {}
  for (const def of getAvailableCommunicationCategoryDefs()) {
    values[categoryFieldKey(def.category)] = !isCategoryOptedOut(prefs, def.category)
  }
  for (const channel of CHANNEL_OPT_OUT_TOGGLES) {
    values[channelFieldKey(channel)] = !isChannelOptedOut(prefs, channel)
  }
  return values
}

// Form values -> stored prefs. Explicit booleans so re-enabling clears the opt-out.
// Merges onto `existing` so opt-outs for categories/channels not rendered for this
// audience (e.g. hidden/unavailable ones) are preserved rather than wiped on save.
export const valuesToCommunicationPreferences = (
  values: SettingsValues,
  existing?: CommunicationPreferences
): CommunicationPreferences => {
  const channelOptOuts: Partial<Record<CommunicationChannel, boolean>> = { ...existing?.channelOptOuts }
  for (const channel of CHANNEL_OPT_OUT_TOGGLES) {
    channelOptOuts[channel] = values[channelFieldKey(channel)] === false
  }
  const categoryOptOuts: Partial<Record<CommunicationCategory, boolean>> = { ...existing?.categoryOptOuts }
  for (const def of getAvailableCommunicationCategoryDefs()) {
    categoryOptOuts[def.category] = values[categoryFieldKey(def.category)] === false
  }
  return { channelOptOuts, categoryOptOuts }
}
